import React, { Component } from 'react';

class Input extends Component {
	render() {
		return <input placeholder = {this.props.placeholder}
			type = 'text'
			autoComplete = 'off'
			autoCorrect  = 'off'
			autoCapitalize = 'off'
			spellCheck = 'false'
			attr = {this.props.attr}
			onChange = {this.props.onChange}
			onKeyUp = {this.props.onKeyUp}
			value = {this.props.value}
			className = 'pt-fill pt-large pt-input'
		/>
	}
}

export default Input;



// WEBPACK FOOTER //
// ./src/components/login/Input.js